// @ts-strict-ignore
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { ArticleUtils } from '@article/util/article-utils';

@Component({
  standalone: false,
  selector: 'app-choice-action-manual-articleno',
  templateUrl: './choice-action-manual-articleno.component.html',
  styleUrls: ['./choice-action-manual-articleno.component.scss']
})
export class ChoiceActionManualArticlenoComponent {

  @Output()
  public finish = new EventEmitter<boolean | undefined>();

  @Input()
  public articleNo: string;

  public useDefaultSeries: boolean = false;

  constructor(private bsModalRef: BsModalRef) {
  }

  public onCancel() {
    this.finish.emit(undefined);
    this.close();
  }

  private close() {
    this.bsModalRef.hide();
  }

  public onConfirm() {
    this.finish.emit(this.useDefaultSeries);
    this.close();
  }

  public getPreviewGeneratedArticleNo(useSeries: boolean = true): string {
    const articleNoPadded: string = ArticleUtils.addLeadingZerosInArticleNumber(this.articleNo);
    if (useSeries) {
      return articleNoPadded + '/Zxxx-xxxx';
    }
    return articleNoPadded.replace(/(\d{3,4})$/, '0099') + '/Zxxx-xxxx';
  }
}
